<template>
  <div id="app">
    <VNavbar
      v-if="inApp"
      background-color="transparent"
      :show-back="true"
      title=""
      color="#000"
      @back="handleBackEvent"
    ></VNavbar>
    <div v-else id="header" />
    <div id="wrap">
      <div id="video-wrap">
        <video preload="auto" autoplay muted playsinline poster="no-poster">
          <source
            src="./assets/dove.mp4"
            type="video/mp4"
          />
          <source
            src="./assets/dove.webm"
            type="video/webm"
          />
        </video>
      </div>
      <section class="wrap-01">
        <img src="./images/background_1@2x.png" alt="">
      </section>
      <section class="wrap-02">
        <img src="./images/background_2@2x.png" alt="">
        <ul class="fix-url-list">
          <li class="usual-url" @click="linkUrl('https://www.bilibili.com/blackboard/pangu/gmxz.html', 'web')"></li>
          <li class="watch-url" @click="linkUrl('https://www.bilibili.com/blackboard/pangu/szcpxsmore.html', 'web')"></li>
          <li class="spinoff-make-url" @click="linkUrl('https://www.bilibili.com/blackboard/pangu/yspzzmore.html', 'web')"></li>
          <li class="sec-make-url" @click="linkUrl('https://www.bilibili.com/blackboard/pangu/xsnrczmore.html', 'web')"></li>
        </ul>
      </section>
      <section class="wrap-03">
        <img src="./images/background_3@2x.png" alt="">
      </section>
    </div>
    <template>
        <!-- 报名成功 继续下一步 -->
        <div v-if="btn_status === 2" class="enroll-btn btn" @click="linkSuccessUrl">
          <img src="./images/button-success@2x.png" alt="">
        </div>
        <!-- 报名结束 -->
        <div v-else-if="btn_status === 3" class="disable-btn btn">
          <img src="./images/button-disabled@2x.png" alt="">
        </div>
        <!-- 立即报名 -->
        <div v-else class="btn" @click="submit">
          <img src="./images/button-click@2x.png" alt="">
        </div>
      </template>
  </div>
</template>

<script>
import { VToast, VNavbar } from '@bilibili/sakura'
import { initEnv, inBiliApp, biliBridge } from '@bilibili/js-bridge'
import { bjax, getApplyInfo, getApplyCurrent, apply } from './api'

const toast = VToast()

const createLink = (url) => {
  const link = encodeURIComponent(url)
  return `bilibili://browser?url=${link}`
}

const getScript = (src, onLoad, onError) => {
  const script = document.createElement('script')
  document.body.appendChild(script)
  script.async = true
  script.onload = () => {
    onLoad && onLoad()
  }
  script.onerror = () => {
    onError && onError()
  }
  script.src = src
}

export default {
  name: 'App',
  components: {
    VNavbar,
  },
  data() {
    return {
      mid: '',
      item_id: '',
      dress_item_id: '',
      inApp: inBiliApp,
      /**
       * 报名状态
       * 0：默认
       * 1：已购买
       *
      */
      apply_status: 0,

      /**
       * 用户状态
       * -1：接口请求中
       * 0：不可以发
       * 1: 白名单内可以发
       *
      */
      user_status: -2,
      now: 0,
      deadline: 0,
      start_time: 0,  // 活动开始时间
      end_time: 0,  // 活动结束时间
      loading: false,
    }
  },

  computed: {
    btn_status() {
      if (this.apply_status === 1) return 2 // 已报名
      else if (this.now > this.deadline) return 3  // 已截止
      return 1  // 立即报名
    },
  },

  created() {
    this.loadHeader()
    // 获取用户状态
    this.getPageInfo().then(() => {
      getApplyInfo({
        item_id: this.item_id
      }).then(({ apply_status, user_status }) => {
        this.apply_status = apply_status
        this.user_status = user_status
        this.validAuth()
      }).catch(res => {
        toast.info(res?.message || 'ops，服务正在施工')
      })
    })
  },

  mounted() {
    initEnv()
    this.$nextTick(() => {
      const videoDom = document.querySelector('video')
      let rect = videoDom.getBoundingClientRect()
      videoDom.style.height = rect.width * 1218 / 562 + 'px'
    })
  },

  methods: {
    parseUA() {
      let version
      let device
      let isPC
      isPC = !/mobile/gi.test(navigator.userAgent.toLowerCase())
      window.navigator.userAgent.split(' ').forEach((item) => {
        if (/^biliapp/i.test(item)) {
          version = +item.split('/')[1]
        } else if (/^mobi_app/i.test(item)) {
          device = item.split('/')[1]
        }
      })
      return {
        version,
        device,
        isPC
      }
    },
    handleBackEvent() {
      biliBridge.callNative({
        method: 'global.closeBrowser',
        callback: function () {}
      })
    },
    loadHeader() {
      getScript(
        'https://s1.hdslb.com/bfs/seed/laputa-header/bili-header.umd.js',
        () => {
          const el = document.getElementById('header')
          // eslint-disable-next-line
          const header = new BiliHeader({
            config: {
              forceVersion: 3,
              headerType: 'mini',
              theme: 'light',
              background: 'transparent',
              disableChannelEntry: true
            }
          })
          header.init(el)
        }
      )
    },
    getUserInfo() {
      return new Promise((resolve, reject) => {
        bjax
          .user()
          .then((res) => {
            if (res && res.mid) {
              this.mid = res.mid
              resolve(res)
            }
            else reject({ message: '请先返回登录后，再进入本页面继续操作' })
          })
          .catch(reject)
      })
    },

    fetchCurrentInfo() {
      return new Promise((resolve, reject) => {
        getApplyCurrent().then(res => {
          this.item_id = res?.item_id
          this.start_time = res?.start_time
          this.end_time = res?.end_time
          this.deadline = res?.end_time
          this.dress_item_id = res?.dress_item_id
          this.now = Date.now() / 1000
          resolve(res)
        }).catch(reject)
      })
    },

    getPageInfo() {
      return new Promise(resolve => {
        Promise.all([this.getUserInfo(), this.fetchCurrentInfo()]).then(res => {
          resolve(res)
        }).catch((err) => {
          toast.info(err.message || 'ops，服务器抢救中')
        })
      })
    },

    validAuth() {
      // 已报名
      if (this.apply_status === 1) return

      // 活动尚未开始
      if (this.start_time > this.now) {
        toast.info('活动不在有效期内，请退出此页面')
        return
      }

      // if (this.end_time < this.now) {
      //   toast.info('活动已结束')
      //   return
      // }

      if (this.now > this.deadline) {
        toast.info('报名已截止')
        return
      }

      if (!this.inApp) {
        toast.info('请在APP内访问该页面查看详情')
        return
      }

      // 不在客户端内或不满6级
      if(!this.mid) {
        toast.info('请先返回登录后，再进入本页面继续操作')
        return false
      }

      if (this.user_status === -2) {
        toast.info('状态同步中，可退出重试')
        return false
      }

      // 不在白名单内
      if(this.user_status !== 1) {
        toast.info('您不符合本次活动的报名资格，请仔细查看页面报名资格说明')
        return false
      }
      return true
    },

    linkUrl(url, type) {
      const { isPC } = this.parseUA()
      if (type && type === 'web' && isPC) {
        return window.open(url)
      }
      if (inBiliApp) {
        biliBridge.callNative({
          method: 'ability.openScheme',
          data: {
            url: createLink(url)
          }
        })
      } else {
        toast.info('请在APP内访问该页面查看详情')
      }
    },

    linkSuccessUrl() {
      this.linkUrl(`https://${process.env.PUSH_ENV === 'uat' ? 'uat-' : ''}www.bilibili.com/h5/mall/digital/avatar?id=${this.dress_item_id}&navhide=1`)
    },

    submit() {
      if (!this.validAuth()) return
      if (this.loading) return
      this.loading = true

      apply({
        item_id: this.item_id
      }).then(res => {
        if (res.status === 1) {
          toast.info('报名成功后，继续前往购买页预约')
          this.apply_status = 1
        } else {
          toast.info('报名失败')
        }
      }).catch(res => {
        toast.info(res?.message || 'ops，服务正在施工')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss">
%font-weight-400 {
  font-family: PingFang SC, HarmonyOS_Regular, Helvetica Neue, Microsoft YaHei,
    sans-serif;
  font-weight: 400;
  @media (-webkit-max-device-pixel-ratio: 1) {
    font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
      Arial, PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif;
  }
}

* {
  margin: 0;
  padding: 0;
  @extend %font-weight-400;
}

i {
  font-style: normal;
}

html, body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
body {
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
}

#wrap {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  @media (min-width: 500px) {
    width: 500px;
    margin: 0 auto;
  }
}

#video-wrap {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 15.4%;
  overflow: hidden;
  background: transparent;
  z-index: 10;
  video {
    display: block;
    width: 100%;
  }
}

section {
  position: relative;
  user-select: none;
  > img {
    display: block;
    width: 100%;
  }
}

.btn {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  user-select: none;
  @media (min-width: 500px) {
    width: 500px;
  }
  > img {
    display: block;
    width: 100%;
  }
  &.enroll-btn {
    cursor: pointer;
  }
}

.fix-url-list {
  li {
    position: absolute;
    left: 14%;
    width: 72%;
    opacity: 0;
    // background: red;
    cursor: pointer;
    &.usual-url {
      top: 22%;
      height: 4%;
      width: 76%;
    }
    &.watch-url {
      top: 51.4%;
      height: 5%;
    }
    &.spinoff-make-url {
      top: 71.4%;
      height: 4%;
    }
    &.sec-make-url {
      top: 90.2%;
      height: 4%;
    }
  }
}
</style>
